<template>
    <div class="result">
        <!-- <h1>Result page</h1> -->
        <v-app>
            <div id="grad">
                <v-container fill-height mt-n13>
                    <v-row justify="center" align="center">
                        <v-col align="center">
                            <v-card width="263px">
                                <v-card-actions class="justify-center">
                                    <img :src="imageLink" height="150" />
                                </v-card-actions>
                                <v-card-title>You scored {{ numCorrect }} out of 20.</v-card-title>
                                <v-card-actions class="justify-center">
                                    <v-btn :to="{ name:'SubjectQuiz' , params:{ id: $route.params.id != null ? $route.params.id : this.id , name: $route.params.name != null ? $route.params.name : this.name }}" class="primary links">
                                        Continue
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </v-app>
    </div>
</template>



<script>

import db from '@/fb'

export default {
    props: [
        'numCorrect'
    ],
    data () {
        return {
            id: '',
            name: '',
            imageLink: null
        }
    },
    created () {
        if (this.numCorrect < 9) {
            this.imageLink = "/poor.jpeg"
        }
        else if (this.numCorrect < 17) {
            this.imageLink = "/fair.jpeg"
        }
        else {
            this.imageLink = "/champ.jpeg"
        }

        var id = this.$route.params.id ;
        var name =  this.$route.params.name ;
        if (name == null) {
            let ref = db.collection('Subjects').doc(id)
        	ref.get().then(snapshot => {
                if (snapshot.exists) {
                    var post = snapshot.data();
                    this.name = post['Name'];
                }
                else {
                    console.log("No such document!");
                }
            })
        }
    }
}

</script>



<style lang="scss" scoped>

#grad {
    background-image: linear-gradient( #3594DD ,#5B16D0);
    height: 100%;
}

// a {
//     text-decoration: none;
// }

.links {
    text-decoration: none;
}

</style>